import { Bouton, Icone } from './ui';
import { AMBRE, AMBRE_BG, AMBRE_FG, RAYON_GROUPE, TEXTE_MUET, TEXTE_SECONDAIRE } from '../theme';

/** Ligne de chargement / erreur / vide partagée par les écrans de liste. */
export function Chargement({ texte = 'Chargement…' }) {
  return (
    <div className="aqs-nav-fondu" style={{ padding: '40px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, fontSize: 15, color: TEXTE_SECONDAIRE }}>
      <span className="aqs-indicateur" aria-hidden="true" />
      {texte}
    </div>
  );
}

export function MessageErreur({ texte, onReessayer }) {
  return (
    <div role="alert" className="aqs-apparition" style={{ background: AMBRE_BG, borderRadius: RAYON_GROUPE, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <span style={{ color: AMBRE, display: 'inline-flex' }}><Icone.Attention taille={22} /></span>
      <span className="aqs-para" style={{ fontSize: 15, fontWeight: 500, color: AMBRE_FG, flex: 1, minWidth: 160 }}>{texte}</span>
      {onReessayer && (
        <Bouton variante="surface" onClick={onReessayer} style={{ color: AMBRE_FG, fontSize: 15 }}>
          Réessayer
        </Bouton>
      )}
    </div>
  );
}

export function EtatVide({ texte }) {
  return (
    <div className="aqs-nav-fondu" style={{ padding: '48px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, textAlign: 'center' }}>
      <span style={{ color: TEXTE_MUET, opacity: 0.6, display: 'inline-flex' }}><Icone.Nuage taille={40} /></span>
      <span className="aqs-para" style={{ maxWidth: 440, fontSize: 16, color: TEXTE_MUET }}>{texte}</span>
    </div>
  );
}
